var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevelUps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#5F6F7C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4624 25.8847C29.575 26.4548 30.8199 27.0926 32.4384 27.0926C35.5205 27.0926 40.3151 23.3035 41 19.5143C40.0868 19.8587 37.8493 20.5477 36.2055 20.5477C34.5616 20.5477 32.0959 18.4808 32.0959 18.4808C32.0959 18.4808 29.0822 14.3472 25.2466 14.3472C21.411 14.3472 19.9954 15.9547 19.7671 16.7585V27.7816C21.875 25.918 23.1264 25.3231 25.589 25.0258C26.5579 24.9089 27.4561 25.3691 28.4624 25.8847ZM16 35.3768C16.8654 36.6129 17.9047 37.7169 19.0822 38.6527V16.9306C19.0822 16.0745 18.3922 15.3805 17.5411 15.3805C16.69 15.3805 16 16.0745 16 16.9306V35.3768Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevelUps);
export default __webpack_public_path__ + "static/media/LevelUps.2d2eebafbbedd5d034f651d2a62b1f2f.svg";
export { ForwardRef as ReactComponent };